import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getRegisterSMSVerifyCode = (params, urlParams) => {
  return axios.request({
    url: '/accountex/getregistersmsverifycode/' + params.telephone + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const bindMobilephone = (params, urlParams) => {
  return axios.request({
    url: '/accountex/bindmobilephone/' + params.code + '/' + params.mobilephone + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const registerAndLoginByWechat = (params, urlParams) => {
  return axios.request({
    url: '/accountex/registerandloginbywechat' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

